import {Typography} from '@mui/material';
import {LocalizationProvider, TimePicker, TimePickerProps} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

export interface AppTimePickerProps extends TimePickerProps<Date, any> {
    label: string;
    required: boolean;
}

export const AppTimePicker: React.FC<AppTimePickerProps> = ({label, required, ...rest}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Typography variant="body2" style={{marginBottom: '5px'}}>
                {label} {required && <span style={{color: 'red'}}>*</span>}
            </Typography>
            <TimePicker
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: 'small',
                    },
                }}
                {...rest}
            />
        </LocalizationProvider>
    );
};

export default AppTimePicker;
